module.exports = __webpack_public_path__ + "img/plot-item-handler.e48f5f34.svg";